import './salaries-modal.scss';

import type { ColumnsType } from 'antd/es/table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SYMBOLS } from '@/shared/constants';
import { formatDate, formatPrice } from '@/shared/services/formatters';
import type {
  ISalariesList,
  ISalaryDeduction
} from '@/shared/types/scoring-info.types';

import ListTable from '../list-table';
import Modal from '../modal';
import { formatPaymentPeriod } from './helpers/period';

interface IProps {
  open: boolean;
  onClose: () => void;
  data: ISalariesList;
}

/** Детализация доходов клиента по отчислениям работодателей — новые сверху. */
const SalariesModal: React.FC<IProps> = ({ open, onClose, data }) => {
  const { t } = useTranslation();
  const deductions = useMemo(
    () => [...data.deductionDetailed].reverse(),
    [data.deductionDetailed]
  );

  const columns = useMemo<ColumnsType<ISalaryDeduction>>(
    () => [
      { title: t('scoringInfo.salaries.bin'), dataIndex: 'bin', width: 120 },
      {
        title: t('scoringInfo.salaries.date'),
        dataIndex: 'date',
        width: 150,
        render: (date: string) => formatDate(date) || SYMBOLS.longDash
      },
      { title: t('scoringInfo.salaries.name'), dataIndex: 'name', width: 200 },
      {
        title: t('scoringInfo.salaries.paymentSum'),
        dataIndex: 'paymentSum',
        width: 150,
        render: (value: number) => formatPrice(value)
      },
      {
        title: t('scoringInfo.salaries.paymentPeriod'),
        dataIndex: 'paymentPeriod',
        width: 150,
        render: formatPaymentPeriod
      },
      {
        title: t('scoringInfo.salaries.totalPaymentSum'),
        dataIndex: 'totalPaymentSum',
        width: 180,
        render: (value: number) => formatPrice(value)
      }
    ],
    [t]
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('scoringInfo.salaries.title')}
      width={1100}
    >
      <div className="salaries-modal">
        <dl className="salaries-modal__info">
          <div>
            <dt className="salaries-modal__label">
              {t('scoringInfo.salaries.requestIin')}
            </dt>
            <dd className="salaries-modal__value">
              {data.requestIin || SYMBOLS.longDash}
            </dd>
          </div>
          <div>
            <dt className="salaries-modal__label">
              {t('scoringInfo.salaries.responseDate')}
            </dt>
            <dd className="salaries-modal__value">
              {formatDate(data.responseDate) || SYMBOLS.longDash}
            </dd>
          </div>
        </dl>

        <ListTable<ISalaryDeduction>
          rowKey={(row) => `${row.bin}-${row.date}-${row.paymentPeriod}`}
          dataSource={deductions}
          columns={columns}
        />
      </div>
    </Modal>
  );
};

export default SalariesModal;
